import getComposeLinkViewState from './getComposeLinkViewState';

export default function isContextMenuOpen(linkId: string): boolean {
    const composeLinkViewState = getComposeLinkViewState(linkId);

    return composeLinkViewState ? composeLinkViewState.isContextMenuOpen : false;
}
